import type { FunctionComponent, PropsWithChildren } from 'react'
import React, { createContext, useContext, useState } from 'react'

export const MenuPortalContext = createContext<HTMLElement | null>(null)

export const useMenuPortalTarget = (): HTMLElement | null => useContext(MenuPortalContext)

export const MenuPortalProvider: FunctionComponent<PropsWithChildren<{}>> = ({ children }) => {
  const [el, setEl] = useState<HTMLDivElement | null>(null)
  return (
    <MenuPortalContext.Provider value={el}>
      {children}
      <div ref={setEl} style={{ position: 'fixed', top: 0, left: 0, zIndex: 9999 }} />
    </MenuPortalContext.Provider>
  )
}
